import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";
import { APIEndpoints } from "@/constants/apiEndpoints";
import type { IApiResponse } from "@/types";
import type {
  IDigitalIdSettings,
  IUpdateDigitalIdSettingsPayload,
} from "@/types/digital-id.interface";

export const companyDigitalIdSettingsApi = createApi({
  reducerPath: "companyDigitalIdSettingsApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["DigitalIdSettings"],
  endpoints: (builder) => ({
    getDigitalIdSettings: builder.query<
      IApiResponse<IDigitalIdSettings>,
      void
    >({
      query: () => ({ url: APIEndpoints.DigitalId.CompanySettings }),
      providesTags: ["DigitalIdSettings"],
    }),
    updateDigitalIdSettings: builder.mutation<
      IApiResponse<IDigitalIdSettings>,
      IUpdateDigitalIdSettingsPayload
    >({
      query: (body) => ({
        url: APIEndpoints.DigitalId.CompanySettings,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["DigitalIdSettings"],
    }),
  }),
});

export const {
  useGetDigitalIdSettingsQuery,
  useUpdateDigitalIdSettingsMutation,
} = companyDigitalIdSettingsApi;
